import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Home } from './pages/Home';
import { About } from './pages/About';
import { ServicesHub } from './pages/ServicesHub';
import { Contact } from './pages/Contact';
import { Gallery } from './pages/Gallery';
import { Residential } from './pages/services/Residential';
import { RoofCleaning } from './pages/services/RoofCleaning';
import { GutterCleaning } from './pages/services/GutterCleaning';
import { DrivewayCleaning } from './pages/services/DrivewayCleaning';
import { DeckCleaning } from './pages/services/DeckCleaning';
import { FenceCleaning } from './pages/services/FenceCleaning';
import { Commercial } from './pages/Commercial';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<Layout data-id="element-3" />} data-id="element-2">
          <Route index element={<Home data-id="element-5" />} data-id="element-4" />
          <Route path="about" element={<About data-id="element-7" />} data-id="element-6" />
          <Route path="services" element={<ServicesHub data-id="element-9" />} data-id="element-8" />
          <Route path="services/residential" element={<Residential data-id="element-11" />} data-id="element-10" />
          <Route path="services/roof" element={<RoofCleaning data-id="element-13" />} data-id="element-12" />
          <Route path="services/gutter" element={<GutterCleaning data-id="element-15" />} data-id="element-14" />
          <Route path="services/driveway" element={<DrivewayCleaning data-id="element-17" />} data-id="element-16" />
          <Route path="services/deck" element={<DeckCleaning data-id="element-19" />} data-id="element-18" />
          <Route path="services/fence" element={<FenceCleaning data-id="element-21" />} data-id="element-20" />
          <Route path="commercial" element={<Commercial data-id="element-23" />} data-id="element-22" />
          <Route path="gallery" element={<Gallery data-id="element-25" />} data-id="element-24" />
          <Route path="contact" element={<Contact data-id="element-27" />} data-id="element-26" />
        </Route>
      </Routes>
    </BrowserRouter>;
}